export const mockDPP = [
  {
    eventId: "TRICK-EVENT-0",
    date: "2022-08-22",
    BusinessStepCode: "REC",
    manufacturingStepCode: "0",
    description: "First action (receiving raw materials)",
    eventReadLocationCountry: "AG", //eventReadLocation
    eventBusinessLocationCountry: "IT",
    certificate: "CB-OIA-25215-59",
    transportDistanceKMT: 13000.0,
    Description: "Receiving RWS certified wool fibers from Argentina",
  },
  {
    eventId: "TRICK-EVENT-1-subcontracted-spinning-2",
    date: "2023-07-16",
    BusinessStepCode: "MNF",
    manufacturingStepCode: "1",
    description:
      "Subcontracted yarn production, from combed fibers stored at warehouses of subcontractor",
    eventReadLocationCountry: "IT",
    eventBusinessLocationCountry: null,
    certificate: null,
    transportDistanceKMT: 30.0,
    Description: null,
  },
  {
    eventId: "TRICK-EVENT-2-weaving",
    date: "2023-11-30",
    BusinessStepCode: "MNF",
    manufacturingStepCode: "2.2",
    description: "Production of greige fabric from yarn",
    eventReadLocationCountry: "IT",
    eventBusinessLocationCountry: null,
    certificate: null,
    transportDistanceKMT: null,
    Description: null,
  },
  {
    eventId: "TRICK-EVENT-3 dyeing",
    date: "2023-12-15",
    BusinessStepCode: "MNF",
    manufacturingStepCode: "3.2.2",
    description: "Greige fabric dyeing",
    eventReadLocationCountry: "IT",
    eventBusinessLocationCountry: null,
    certificate: "ICA-GRS-21-2250/00C",
    transportDistanceKMT: null,
    Description: null,
  },
  {
    eventId: "TRICK-EVENT-4-finishing",
    date: "2023-12-16",
    BusinessStepCode: "MNF",
    manufacturingStepCode: "3",
    description: "Finishing and cut into small pieces",
    eventReadLocationCountry: "IT",
    eventBusinessLocationCountry: null,
    certificate: null,
    transportDistanceKMT: null,
    Description: null,
  },
  {
    eventId: "TRICK-EVENT-5 - subcontracted garment manufacturing",
    date: "2024-01-10",
    BusinessStepCode: "MNF",
    manufacturingStepCode: "4",
    description:
      "Subcontracted garment manufacturing: cut and sew and dispatching",
    eventReadLocationCountry: "IT",
    eventBusinessLocationCountry: null,
    certificate: null,
    transportDistanceKMT: null,
    Description: null,
  },
  {
    eventId: "TRICK-EVENT-6 export",
    date: "2024-01-18",
    BusinessStepCode: "SEL",
    manufacturingStepCode: null,
    description: "Shipment to the store in Canada",
    eventReadLocationCountry: "IT",
    eventBusinessLocationCountry: "CA",
    certificate: null,
    transportDistanceKMT: 8000.0,
    Description: "Shipment to the store in Canada",
  },
];
export const mockPCO = {
  certificateFlag: true,
  productOrigin: "IT",
  mainManufacturingOperationCountries: [
    {
      country: "AG",
      manufacturingOperationCode: 0,
    },
    {
      country: "IT",
      manufacturingOperationCode: 1,
    },
    {
      country: "IT",
      manufacturingOperationCode: 2,
    },
    {
      country: "IT",
      manufacturingOperationCode: 3,
    },
  ],
};
export const mockPEF = {
  disclosureLevel: 1,
  groupName: "Indicators from Piacenza's PEF study",
  methodology: "PEF",
  methodologicalNote: {
    functionalUnit: "1 coat for man (5708), 1 coat for woman (5704)",
    systemBoundaries:
      "The system boundaries include the following phases: raw material supply, spinning, weaving, dyeing, finishing, subcontracted garment manufacture, selling",
    limitation: "None",
    referenceYear: 2018,
    allocations:
      "Allocation of the environmental impacts was applied where primary data was not available",
    dataQuality: "Primary data collected through Piacenza ERP",
  },
  indicators: [
    {
      name: "PEF-CC",
      value: "1.24E-01",
      disclosureLevel: 1,
      validationMethod: "REV",
      statusCode: 73,
    },
    {
      name: "PEF-PM",
      value: "6.89E-05",
      disclosureLevel: 1,
      validationMethod: "REV",
      statusCode: 73,
    },
    {
      name: "PEF-POZ",
      value: "3.39E-04",
      disclosureLevel: 1,
      validationMethod: "REV",
      statusCode: 73,
    },
    {
      name: "PEF-EUT",
      value: "1.17E-02",
      disclosureLevel: 1,
      validationMethod: "REV",
      statusCode: 73,
    },
    {
      name: "PEF-EUM",
      value: "9.26E-04",
      disclosureLevel: 1,
      validationMethod: "REV",
      statusCode: 73,
    },
    {
      name: "PEF-ECW",
      value: "7.53E-01",
      disclosureLevel: 1,
      validationMethod: "REV",
      statusCode: 73,
    },
    {
      name: "PEF-LND",
      value: "2.19E-04",
      disclosureLevel: 1,
      validationMethod: "REV",
      statusCode: 73,
    },
    {
      name: "PEF-WAS",
      value: "2.05E-06",
      disclosureLevel: 1,
      validationMethod: "REV",
      statusCode: 73,
    },
  ],
  reviewedFlag: true,
  studyDocument: {
    year: 2024,
    publishableAbstract:
      "This is a publishable abstract: Lupus et agnus ad rivum eundem venerunt.....",
    author: {
      name: "Valentina Fantin",
      email: "email18",
      phone: "phone18",
      fax: "fax18",
    },
    reviewer: {
      id: "Reviewer1",
      name: "Mario Rossi",
      email: "email19",
      phone: "phone19",
      fax: "fax19",
      country: "DE",
    },
    attachment: {
      uid: "PEF_PIAC_01",
      blockchainReference: {
        uri: "www.quadrans.io/xyz",
        transactionReceipt:
          "8450895750035721057457210570125710259217589217589127",
      },
    },
  },
};

export const trickDPP = {
  traceReports: {
    reportId: "TRICK-REPORT-0",
    timestamp: "2022-08-22",
    publicTraceID: "TRICK-TRACE-0",
    trcSteps: mockDPP,
  },
  pcoReports: mockPCO,
  pefReports: mockPEF,
};
